import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './styles.scss'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import '../theme/fonts/font_3670948_2jvvbvrko6m/iconfont.css'
import '../theme/index.css'
import '../theme/customize.less'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
